import type { ReactNode } from 'react';
import { Paper, Stack, Typography } from '@mui/material';

/**
 * One module of the Admin screen.
 *
 * This was an accordion. Admin had grown into a single column several screens
 * tall, and collapsing each block put the whole screen back on one page. The
 * side nav does that job now — one module is on screen at a time and the rest
 * are not mounted, nor even downloaded — so a block states its heading and
 * shows its contents instead of hiding them behind a second click.
 *
 * Every panel wraps itself in this, which is why the accordion could be taken
 * out here rather than in eight separate files.
 */
export function AdminSection({
  title, summary, children,
}: {
  title: string;
  /** Chips or a line of text beside the heading. */
  summary?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 1 }}>
      <Stack
        direction="row"
        spacing={1.5}
        useFlexGap
        sx={{ alignItems: 'center', flexWrap: 'wrap', minWidth: 0, mb: 2 }}
      >
        <Typography variant="h2" sx={{ flex: 1 }}>{title}</Typography>
        {summary}
      </Stack>
      {children}
    </Paper>
  );
}
